import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogModule, MAT_DIALOG_DATA, MatDialogContent } from '@angular/material/dialog';
import * as fselib from 'mercalink-fselib';
import { FseDateTimeToFrPipe } from '@app/shared/pipes/format-currency.pipe';
import { MatButtonModule } from '@angular/material/button'; // Import MatButtonModule
import { BsDialogComponent } from 'mercalink-fselib'; // Import BsDialogComponent
import { environment } from '../../../environments/environment'; // Assuming environment is accessible

export interface DossiersScoreDialogData {
	server_url: string;
	area_baseurl: string; // Keep area_baseurl for consistency
	fseOrder: fselib.FSEOrder; // Now receiving the full FSEOrder
	userid: number;
	outputDialogData: any;
	attachMode: boolean;
	station: any;
  configarea: any;
}

@Component({
  selector: 'app-dossiers-score',
  standalone: true,
  imports: [MatDialogModule, MatDialogContent, FseDateTimeToFrPipe, MatButtonModule],
  templateUrl: './dossiers-score.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./dossiers-score.component.scss', '../fses/fses.component.scss']
})
export class DossiersScoreComponent {
  readonly dialogdata = inject<DossiersScoreDialogData>(MAT_DIALOG_DATA as any);
  public docs: fselib.FseDoc[] = [];
  private dialog = inject(MatDialog); // Inject MatDialog

  constructor() {}

  ngOnInit(): void {
    this.docs = this.dialogdata.fseOrder.lnk_docs || []; // Access docs from the fseOrder object
  }

  /**
   * Opens the BsDialogComponent, similar to the openbsdialog function in FsesComponent.
   * It uses the FSEOrder data passed to this dialog.
   */
  openBsDialogFromDossier(event: Event) {
    event.stopPropagation();
    const area_baseurl = this.dialogdata.area_baseurl;
    if (!area_baseurl) return;

    this.dialog.open(fselib.BsDialogComponent, {
      height: 'unset',
      maxWidth: 'unset',
      data: {
        server_url: environment.server_url,
        area_baseurl: area_baseurl,
        order_id: this.dialogdata.fseOrder.id_order,
        fse_id: this.dialogdata.fseOrder.id,
        userid: this.dialogdata.userid,
        outputDialogData: { empreinteCV: this.dialogdata.fseOrder.data.empreinteCV, index: this.dialogdata.fseOrder.data.index, numIdentFact: this.dialogdata.outputDialogData.numIdentFact },
        attachMode: this.dialogdata.attachMode,
        station: this.dialogdata.station,
        configarea: this.dialogdata.configarea
      },
    });
  }
}
